import dashboard from '@/router/routes/dashboard'
import authentication from '@/router/routes/authentication'
import user from '@/router/routes/user'
import tasks from '@/router/routes/tasks'
import calendar from '@/router/routes/calendar'
import orders from '@/router/routes/orders'
import documents from '@/router/routes/documents'
import typeform from '@/router/routes/typeform'
import reports from '@/router/routes/reports'
import marketplace from '@/router/routes/marketplace'
import companySettings from '@/router/routes/companySettings'
import emma from '@/router/routes/emma'
import gamification from '@/router/routes/gamification'
import migration from '@/router/routes/migration'
import license from '@/router/routes/license'

export default [
    ...dashboard,
    ...authentication,
    ...user,
    ...tasks,
    ...calendar,
    ...orders,
    ...documents,
    ...typeform,
    ...reports,
    ...marketplace,
    ...companySettings,
    ...emma,
    ...gamification,
    ...migration,
    ...license,
]
